export const drbMetadata = (
  data: any
): {
    version: string, 
    created_by: string,
    created_ts: string,
    status: string,
    last_updated_by: string,
    last_updated_ts: string,
    owner: string,
    contributors: string,
    draft: string,
    deployed_to_stage: string,
    deployed_to_stage_ts: string,
    deployed_to_prod: string,
    deployed_to_prod_ts: string,
} => ({
  version: data['version'],
  created_by: data['created_by'],
  created_ts: data['created_ts'],
  status: data['status'],
  last_updated_by: data['last_updated_by'],
  last_updated_ts: data['last_updated_ts'],
  owner: data['owner'],
  contributors: data['contributors'],
  draft: data['draft'],
  deployed_to_stage: data['deployed_to_stage'],
  deployed_to_stage_ts: data['deployed_to_stage_ts'],
  deployed_to_prod: data['deployed_to_prod'],
  deployed_to_prod_ts: data['deployed_to_prod_ts']
});
